module.exports = __webpack_public_path__ + "static/media/correcao-login-bg.297617ee.png";